<template>

  <div class="vflex">
    <div class="vflex-row-0 p-3">
      <ul class="nav nav-pills">
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ active: step === 'plans' }"
            :to="{ path: '/billing/steps/plans' }">
            Planos
            </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ active: step === 'details', disabled: !hasSelectedPlan }"
            :to="{ path: '/billing/steps/details' }">
            Dados de faturamento
            </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ active: step === 'payment', disabled: !(hasSelectedPlan && hasCustomer) }"
            :to="{ path: '/billing/steps/payment' }">
            Método de pagamento
            </router-link>
        </li>
        <li class="nav-item">
        <router-link
            class="nav-link"
            :class="{ active: step === 'finish', disabled: !(hasSelectedPlan && hasCustomer && hasDefaultPaymethod) }"
            :to="{ path: '/billing/steps/finish' }">
            Finalizar
            </router-link>
        </li>
      </ul>
    </div>
    <div class="vflex-row-1">
      <BillingPlans
        v-if="step === 'plans'"
        is-steps
        @saved="nextStep" />
      <BillingDetails
        v-if="step === 'details'"
        is-steps
        @saved="nextStep" />
      <BillingPayment
        v-if="step === 'payment'"
        is-steps
        @saved="nextStep" />
      <BillingFinish
        v-if="step === 'finish'"
        is-steps
        @saved="nextStep" />
    </div>
  </div>

</template>

<script>
import BillingPlans from './BillingPlans'
import BillingDetails from './BillingDetails'
import BillingPayment from './BillingPayment'
import BillingFinish from './BillingFinish'

export default {
  name: 'BillingSteps',
  components: {
    BillingPlans,
    BillingDetails,
    BillingPayment,
    BillingFinish
  },
  data () {
    return {
      creating: true
    }
  },
  computed: {
    step () {
      return this.$route.params.step
    },
    selectedPlan () {
      return this.$store.getters.getBillingPlan
    },
    hasSelectedPlan () {
      return this.selectedPlan
    },
    billingResume () {
      return this.$store.getters.getBillingResume
    },
    hasCustomer () {
      return this.billingResume.has_customer
    },
    hasDefaultPaymethod () {
      return this.billingResume.has_default_paymethod
    }
  },
  created () {
    if (!this.hasSelectedPlan) {
      this.$router.push('/billing/steps/plans')
    } else if (!this.hasCustomer) {
      this.$router.push('/billing/steps/details')
    } else if (!this.hasDefaultPaymethod) {
      this.$router.push('/billing/steps/details')
    }
  },
  methods: {
    nextStep () {
      if (this.step === 'plans') {
        this.$router.push('/billing/steps/details')
      }
      if (this.step === 'details') {
        this.$router.push('/billing/steps/payment')
      }
      if (this.step === 'payment') {
        this.$router.push('/billing/steps/finish')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingSteps.vue